export default "__VITE_ASSET__DKXfYU5d__"